import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { Services } from './../services-url';

@Injectable({
  providedIn: 'root'
})
export class DepartamentService {

  constructor(
    private http: HttpClient,
  ) { }

  getYears(): Observable<any> {
    return this.http.get(Services.years);
  }

  getDepartaments(): Observable<any> {
    return this.http.get(Services.departaments);
  }

  getIndicator(depId, year): Observable<any> {


    return this.http.get(`${Services.indicatorDepartament}/${year}/${depId}`);
  }

  getIndicatorsDetails(depId, years): Observable<any> {
    return this.http.get(`${Services.indicatoDepartamentDetails}/${depId}/${years[0]}/${years[1]}`);
  }
}
